import { CRASH_DETECTION_INTERVAL } from 'constants';
import getCrashDetectionFunction from 'utilities/crashDetection/getCrashDetectionFunction';
import handleCrashDetected from 'utilities/crashDetection/handleCrashDetected';

/**
 * @method setupCrashDetection
 */
const setupCrashDetection = () => {
  let appCrashedOnce = false;

  const crashDetectionInterval = setInterval(
    getCrashDetectionFunction(() => {
      if (!appCrashedOnce) {
        appCrashedOnce = true;
        handleCrashDetected();
        clearInterval(crashDetectionInterval);
      }
    }),
    CRASH_DETECTION_INTERVAL,
  );
};

export default setupCrashDetection;
